import { TLocoType } from 'shared/hooks/use-loco-translation'
import { AccessTypeEnum, AccessTypeCaptions } from '../enums/access-type-enum'
import { FormSelectDataType, Hint } from '@systemeio/ui'

export function getCourseAccessTypeDataOptions(t: TLocoType): FormSelectDataType<AccessTypeEnum>[] {
  return [
    { id: AccessTypeEnum.fullAccess, caption: t(AccessTypeCaptions[AccessTypeEnum.fullAccess]) },
    {
      id: AccessTypeEnum.drippingContent,
      caption: t(AccessTypeCaptions[AccessTypeEnum.drippingContent]),
    },
    {
      id: AccessTypeEnum.partialAccess,
      caption: t(AccessTypeCaptions[AccessTypeEnum.partialAccess]),
    },
    {
      id: AccessTypeEnum.partialDrippingAccess,
      caption: t(AccessTypeCaptions[AccessTypeEnum.partialDrippingAccess]),
      customCaption: (
        <Hint label={t('dashboard.course.access_type.partial_dripping_access-tooltip')}>
          {t(AccessTypeCaptions[AccessTypeEnum.partialDrippingAccess])}
        </Hint>
      ),
    },
  ]
}
